import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the dashboard invitation link sent by email:
 *   /dashboard/:userId/invitation/:code/:key
 *
 * When a logged-in user lands here we simply forward them to
 * Profile → Dashboard → Invitations.
 */
export default function DashboardInvitationRedirectPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/profile', {
      replace: true,
      state: { tab: 'dashboard', view: 'invitations' },
    });
  }, [navigate]);

  return null;
}
